export default {
    HIPERTENSAO_ESSENCIAL_PRIMARIA: 3702,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA: 3709,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA_COM_INSUFICIENCIA_CARDIACA_CONGESTIVA: 3710,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA_COM_INSUFICIENCIA_CARDIACA_CONGESTIVA_E_INSUFICIENCIA_RENAL: 3712,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA_COM_INSUFICIENCIA_RENAL: 3711,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6482,
    DOENCA_CARDIACA_E_RENAL_HIPERTENSIVA_NAO_ESPECIFICADA: 3713,
    DOENCA_CARDIACA_HIPERTENSIVA: 3703,
    DOENCA_CARDIACA_HIPERTENSIVA_COM_INSUFICIENCIA_CARDIACA_CONGESTIVA: 3704,
    DOENCA_CARDIACA_HIPERTENSIVA_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6480,
    DOENCA_CARDIACA_HIPERTENSIVA_SEM_INSUFICIENCIA_CARDIACA_CONGESTIVA: 3705,
    DOENCA_RENAL_HIPERTENSIVA: 3706,
    DOENCA_RENAL_HIPERTENSIVA_COM_INSUFICIENCIA_RENAL: 3707,
    DOENCA_RENAL_HIPERTENSIVA_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6481,
    DOENCA_RENAL_HIPERTENSIVA_SEM_INSUFICIENCIA_RENAL: 3708,
    HIPERTENSAO_ESSENCIAL_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6479,
    HIPERTENSAO_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6478,
    HIPERTENSAO_PRE_EXISTENTE_NAO_ESPECIFICADA_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6484,
    HIPERTENSAO_PULMONAR_PRIMARIA: 3765,
    HIPERTENSAO_RENOVASCULAR: 3715,
    HIPERTENSAO_SECUNDARIA: 3714,
    HIPERTENSAO_SECUNDARIA_A_AFECCOES_ENDOCRINAS: 3717,
    HIPERTENSAO_SECUNDARIA_A_OUTRAS_AFECCOES_RENAIS: 3716,
    HIPERTENSAO_SECUNDARIA_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6483,
    HIPERTENSAO_SECUNDARIA_NAO_ESPECIFICADA: 3719,
    OUTRA_HIPERTENSAO_PULMONAR_SECUNDARIA: 3767,
    OUTRAS_FORMAS_DE_HIPERTENSAO_SECUNDARIA: 3718,
}

